/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Cp_Partner_TitleInputs */

const en_cp_partner_title = /** @type {(inputs: Cp_Partner_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`What we give, what we ask`)
};

const id_cp_partner_title = /** @type {(inputs: Cp_Partner_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Yang kami beri, yang kami minta`)
};

/**
* | output |
* | --- |
* | "What we give, what we ask" |
*
* @param {Cp_Partner_TitleInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const cp_partner_title = /** @type {((inputs?: Cp_Partner_TitleInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cp_Partner_TitleInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_cp_partner_title(inputs)
	return en_cp_partner_title(inputs)
});